module.exports = __webpack_public_path__ + "fonts/d778218.eot";